import { render, staticRenderFns } from "./ContractProfile.vue?vue&type=template&id=03125bf6&scoped=true&"
import script from "./ContractProfile.vue?vue&type=script&lang=ts&"
export * from "./ContractProfile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03125bf6",
  null
  
)

export default component.exports